import { A11yModule } from '@angular/cdk/a11y';
import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogModule,
} from '@angular/material/legacy-dialog';
import { CountertopAngleProcessingAvailability, OutlineEditorOptions } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Countertop } from '../../models/cutting/countertop';
import { AngleMode } from '../../models/cutting/cutting-panel-outline.model';
import { AngleSettingsModule } from '../countertop-angle-settings/angle-setting.module';

export interface AngleProcessingDialogData {
  angleNumber: number;
  countertop: Countertop;
  angleProcessingAvailability: CountertopAngleProcessingAvailability;
  outlineOptions: OutlineEditorOptions;
}

@Component({
  templateUrl: './countertop-angle-processing-dialog.component.html',
  standalone: true,
  imports: [
    NgIf,
    MatIconModule,
    MatLegacyButtonModule,
    MatLegacyDialogModule,
    AngleSettingsModule,
    AsyncPipe,
    A11yModule,
  ],
})
export class CountertopAngleProcessingDialogComponent {
  _countertop: Countertop;

  constructor(
    private dialog: MatDialogRef<CountertopAngleProcessingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AngleProcessingDialogData
  ) {
    this._countertop = _.cloneDeep(this.data.countertop);
  }

  save(countertop: Countertop): void {
    this.dialog.close(countertop.outline.angleProcessing[this.data.angleNumber]);
  }

  getSchemaLink(): string {
    switch (this._countertop.outline.angleProcessing[this.data.angleNumber]?.mode) {
      case AngleMode.Rounded:
        return 'assets/images/angle-processings/processing-schemas/rounding.svg';

      case AngleMode.Chamfer:
        return 'assets/images/angle-processings/processing-schemas/chamfer.svg';

      case AngleMode.Cutted:
        return 'assets/images/angle-processings/processing-schemas/cut.svg';

      case AngleMode.CuttedInside:
        return 'assets/images/angle-processings/processing-schemas/g-shaped.svg';

      case AngleMode.CuttedInsideWithAngle:
        return 'assets/images/angle-processings/processing-schemas/g-shaped-with-angle.svg';

      case AngleMode.RoundedInside:
        return 'assets/images/angle-processings/processing-schemas/inside-rounding.svg';

      default:
        return '';
    }
  }
}
